<template>
    <el-dialog
        class="ssm-device-operate-dialog"
        :title="(currentRow ? '编辑' : '新增') + '闲置资源'"
        :visible.sync="visible"
        :close-on-click-modal="false"
        top="4%"
        width="980px"
        :before-close="close">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="mini">
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="equipmentName" label="设备名称">
                        <el-input v-model.trim="form.equipmentName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="specification" label="规格型号">
                        <el-input v-model.trim="form.specification" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="idleAmount" label="闲置数量">
                        <el-input v-model.trim="form.idleAmount" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- LSRM端的新增，或来源系统是LSRM的编辑 -->
            <el-row v-if="(!currentRow && !supplier) || (currentRow && currentRow.dataSource === '1')">
                <el-col :span="8">
                    <el-form-item prop="centerName" label="经营中心">
                        <SrmAdvance
                            :params="centerConfig"
                            :mValue="form.centerName"
                            @getAdvanceValue="getCenter"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="physicalWarehouseName" label="物理仓">
                        <SrmAdvance
                            :params="warehouseConfig"
                            :mValue="form.physicalWarehouseName"
                            @getAdvanceValue="getWarehouse"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="leavingFactoryTime" label="出厂时间">
                        <el-date-picker
                            v-model="form.leavingFactoryTime"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择日期"
                            :clearable="true"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-else>
                <el-col :span="8">
                    <el-form-item prop="provinceCode" label="闲置资源省份">
                        <el-select v-model="form.provinceCode" clearable @change="handleProvinceChange">
                            <el-option
                                v-for="option in provinceOptions"
                                :key="option.label + '_' +option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="cityCode" label="闲置资源城市">
                        <el-select v-model="form.cityCode" clearable :disabled="!form.provinceCode" @change="handleCityChange">
                            <el-option
                                v-for="option in cityOptions"
                                :key="option.label + '_' +option.value"
                                :label="option.label"
                                :value="option.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="leavingFactoryTime" label="出厂时间">
                        <el-date-picker
                            v-model="form.leavingFactoryTime"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd"
                            placeholder="请选择日期"
                            :clearable="true"
                        ></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item prop="contacts" label="联系人">
                        <el-input v-model.trim="form.contacts" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="contactNumber" label="联系电话">
                        <el-input v-model.trim="form.contactNumber" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item prop="brand" label="品牌">
                        <el-input v-model.trim="form.brand" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item prop="equipmentRemark" label="设备情况说明">
                        <el-input
                            type="textarea"
                            v-model.trim="form.equipmentRemark"
                            placeholder="请输入"
                            :rows="3"
                            maxlength="100"
                            :show-word-limit="true"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="comfirm">发布</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { getCitys, getDistricts } from '../../../utils/getArea.js'
import { addEqIdleResources, editEqIdleResources } from '../../../api/storageSupManage/idleResource.js';
import { getPersons } from '../../../api/register/person.js';
import { phoneVerify } from '../../../constant/formRegular.js';
import SrmAdvance from '../../../components/srmAdvance/index.vue'

const INITFORM = {
    equipmentName: '',
    specification: '',
    idleAmount: '',
    centerCode: '',
    centerName: '',
    physicalWarehouseCode: '',
    physicalWarehouseName: '',

    provinceCode: '',
    provinceName: '',
    cityCode: '',
    cityName: '',

    leavingFactoryTime: '',
    contacts: '',
    contactNumber: '',
    brand: '',
    equipmentRemark: '',
};

export default {
    components: { SrmAdvance },
    props: {
        provinceOptions: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            currentRow: null,
            visible: false,
            form: { ...INITFORM },
            rules: {
                equipmentName: [
                    { required: true, message: '请输入设备名称', trigger: ['blur', 'change'] },
                    { max: 60, message: '限制输入60个字符', trigger: ['blur', 'change'] }
                ],
                specification: [
                    { required: true, message: '请输入规格型号', trigger: ['blur', 'change'] },
                    { max: 60, message: '限制输入60个字符', trigger: ['blur', 'change'] }
                ],
                idleAmount: [
                    { required: true, message: '请输入闲置数量', trigger: ['blur', 'change'] },
                    { pattern: /^[1-9]\d{0,7}$/, message: '请输入8位以内正整数', trigger: ['blur', 'change'] },
                ],
                centerName: [{ required: true, message: '请选择经营中心', trigger: ['blur', 'change'] }],
                physicalWarehouseName: [{ required: true, message: '请选择物理仓', trigger: ['blur', 'change'] }],
                provinceCode: [{ required: true, message: '请选择省份', trigger: ['blur', 'change'] }],
                cityCode: [{ required: true, message: '请选择城市', trigger: ['blur', 'change'] }],
                leavingFactoryTime: [{ required: true, message: '请选择出厂时间', trigger: ['blur', 'change'] }],
                contacts: [
                    { required: true, message: '请输入联系人', trigger: ['blur', 'change'] },
                    { max: 30, message: '限制输入30个字符', trigger: ['blur', 'change'] }
                ],
                contactNumber: [
                    { required: true, message: '请输入联系电话', trigger: ['blur', 'change'] },
                    { pattern: phoneVerify, message: '请输入正确格式的手机号码', trigger: ['blur', 'change'] },
                ],
                brand: [
                    { required: true, message: '请输入品牌', trigger: ['blur', 'change'] },
                    { max: 60, message: '限制输入60个字符', trigger: ['blur', 'change'] }
                ],
            },
            centerConfig: {
                name: '经营中心',
                value: 'centerName',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '经营中心名称' },
                    { prop: 'escoCompanyNo', value: '经营中心编码' },
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '经营中心编码' },
                    { prop: 'escoCompanyNameCn', value: '经营中心名称' },
                ],
                method: 'post',
                prefix: '/api-srm-web',
                advanceUrl: '/analysis/mdmService/pageSearchBusinessCenter',
                cbParams: ['escoCompanyNo#centerCode', 'escoCompanyNameCn#centerName'],
            },
            warehouseConfig: {
                name: '物理仓',
                value: 'physicalWarehouseName',
                advanceConfig: [
                    { prop: 'ALL', value: '全部' },
                    { prop: 'whName', value: '物理仓名称' },
                    { prop: 'whCode', value: '物理仓编码' },
                ],
                tableConfig: [
                    { prop: 'whCode', value: '物理仓编码' },
                    { prop: 'whName', value: '名称' },
                    { prop: 'whAddress', value: '地址' },
                    { prop: 'whSquare', value: '仓库面积' },
                ],
                advanceUrl: '/supplier/supplierPhysicsWarehouse/pageList',
                prefix: 'api-srm-web',
                method: 'post',
                cbParams: [
                    'whCode#physicalWarehouseCode',
                    'whName#physicalWarehouseName',
                    // 'whNameArray#physicalWarehouseNameArray',
                ],
            },
            pickerOptions: {
                // disabledDate(time) {
                //     return time.getTime() < (new Date()).setHours(0, 0, 0, 0);
                // },
            },
            loading: false,
            cityOptions: [],
            areaOptions: [],
        };
    },
    computed: {
        ...mapState(['supplier']),
        ...mapGetters(['user', 'currentTenant']),
    },
    methods: {
        open(row) {
            this.visible = true;
            if (row) {
                this.currentRow = row;
                this.load(row);
            } else {
                if (this.supplier) {
                    this.setSupplierContactInfo()
                } else {
                    this.form.contacts = this.user.userName
                    this.form.contactNumber = this.user.mobile
                }
            }
        },
        close() {
            this.currentRow = null;
            this.form = { ...INITFORM };
            this.cityOptions = []
            this.areaOptions = []
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
                this.visible = false;
            });
        },
        load(row) {
            Object.keys(this.form).forEach(key => {
                this.form[key] = row[key];
            });
            this.setRegionOptions()
        },
        comfirm() {
            this.$refs.form.validate().then(valid => {
                const operate = this.currentRow ?
                    { api: editEqIdleResources, successMsg: '编辑成功!' } :
                    { api: addEqIdleResources, successMsg: '新增成功!' };
                this.loading = true;
                operate.api(this.getParams()).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(operate.successMsg);
                        this.close();
                        this.$emit('refresh');
                    }
                }).finally(() => { this.loading = false; });
            }).catch(err => {});
        },
        getParams() {
            const params = { ...this.form };
            if (this.currentRow) {
                params.id = this.currentRow.id;
                params.version = this.currentRow.version;
            } else {
                // 数据来源 LSRM'1',LSP'2'
                params.dataSource = !this.supplier ? '1' : '2'
            }
            if (this.supplier) {
                params.supplierCode = this.supplier.supplierCode
            }
            return params;
        },
        setRegionOptions() {
            if (this.form.provinceCode) {
                getCitys(this.form.provinceCode).then(res => {
                    this.cityOptions = res;
                })
            }
            if (this.form.cityCode) {
                getDistricts(this.form.cityCode).then(res => {
                    this.areaOptions = res;
                })
            }
        },
        handleProvinceChange(val) {
            this.form.cityCode = '';
            this.form.provinceName = val ? this.provinceOptions.find(item => item.value === val).label : '';
            this.form.cityName = '';
            this.cityOptions = [];
            if (val) {
                getCitys(val).then(res => {
                    this.cityOptions = res;
                })
            }
        },
        handleCityChange(val) {
            this.form.cityName = val ? this.cityOptions.find(item => item.value === val).label : '';
        },
        setSupplierContactInfo() {
            const params = {
                pageNo: 1,
                pageSize: 99999,
                supplierCode: this.supplier.supplierCode
            }
            getPersons(params).then(res => {
                if (res && +res.code === 0) {
                    // userType=1 为主账号
                    const mainItem = res.data.list.find(item => +item.userType === 1)
                    if (mainItem) {
                        this.form.contacts = mainItem.contacts
                        this.form.contactNumber = mainItem.contactsMobile
                    }
                }
            })
        },
        getCenter(val) {
            this.form.centerCode = val.centerCode
            this.form.centerName = val.centerName
        },
        getWarehouse(val) {
            this.form.physicalWarehouseCode = val.physicalWarehouseCode
            this.form.physicalWarehouseName = val.physicalWarehouseName
        },
    },
};
</script>
<style lang="less">
.ssm-device-operate-dialog {
    .el-date-editor, .el-select {
        width: 100%;
    }
}
</style>